import { Suspense } from "react";
import { useOutletContext, useParams } from "react-router";
import styled from "styled-components";

import ProductLineEditor from "./ProductLineEditor";
import useProductLine from "../../../../clients/brands/useProducLine";

import type { ProductLinesAppOutletContext } from "../../index";

const Styled = styled.section`
    display: flex;
    flex-direction: column;
    gap: 32px;

    header {
        span {
            color: #001;
            font-size: 2.4rem;
        }
    }
`;

export default function ProductLine() {
    const guard = useOutletContext<ProductLinesAppOutletContext>();

    return (
        <Styled>
            <header>
                <span>Product Line</span>
            </header>
            <Suspense fallback={ <span>loading</span> }>
                <ProductLineX guard={ guard } />
            </Suspense>
        </Styled>
    );
}

function ProductLineX({ guard }) {
    const { brandID, productLineID } = useParams();

    const productLine = useProductLine(productLineID);

    return (
        <ProductLineEditor
            guard={ guard }
            productLine={ productLineID ? productLine.data.productLine : { brandID } }
        />
    );
}
